const openDialogIds = [];
let nextDialogNumber = 1;
let originalBodyOverflow = null;

export const createDialogInstanceId = function () {
    const id = `app-dialog-${nextDialogNumber}`;
    nextDialogNumber += 1;
    return id;
};

export const registerDialog = function (id) {
    const existingIndex = openDialogIds.indexOf(id);
    if (existingIndex !== -1) {
        return existingIndex;
    }

    if (typeof document !== 'undefined' && openDialogIds.length === 0) {
        originalBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }

    openDialogIds.push(id);
    return openDialogIds.length - 1;
};

export const unregisterDialog = function (id) {
    const index = openDialogIds.indexOf(id);
    if (index !== -1) {
        openDialogIds.splice(index, 1);
    }

    if (typeof document !== 'undefined' && openDialogIds.length === 0) {
        document.body.style.overflow = originalBodyOverflow || '';
        originalBodyOverflow = null;
    }
};

export const isTopDialog = function (id) {
    return openDialogIds.length > 0 && openDialogIds[openDialogIds.length - 1] === id;
};

